// 智能柜首页，选择寄存
<template>
  <div class="mailSelectCheck">
    <h1 class="title">极酷信报箱</h1>
    <div class="way-list clearfix">
      <router-link :to="{path: '/mailBox/common/selectWay', query:{oType: 'userSave'}}"  class="way">存件</router-link>
      <router-link :to="{path: '/mailBox/common/selectWay', query:{oType: 'userFetch'}}"  class="way">取件</router-link>
      <router-link :to="{path: '/mailBox/common/selectWay', query:{oType: 'userFastSave'}}"  class="way">快速存件</router-link>
    </div>
    <!-- <p class="question">收到快递无法取？试试<a href="#">取件码取件</a></p> -->
  </div>
</template>

<script>

export default {
  name: 'mailBoxSelectCheck',

  data () {
    return {
    }
  },

  created () {
  },

  mounted () {
  },
  
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
.mailSelectCheck {
  width: 100%;
  color: #ffffff;
  text-align: center;
  position: relative;
  .title {
    font-size: 0.7rem;
    line-height: 0.7rem;
    padding: 1.3rem 0 0.6rem;
  }
  .info {
    width: 7.7rem;
    margin: 0 auto;
    font-size: 0.34rem;
    line-height: 0.5rem;
    border: 1px solid #ffffff;
    border-radius: 0.1rem;
    .text:last-child {
      line-height: 1rem;
      border-top: 1px solid #ffffff;
    }
    .text span {
      margin-right: 1em;
    }
  }
  .way-list {
    width: 90%;
    display: flex;
    justify-content: center;
    margin: 0.9rem auto 1.2rem;
    .way {
      width: 3.36rem;
      height: 2.38rem;
      line-height: 2.38rem;
      font-size: 0.6rem;
      font-weight: bold;
      color: #ffffff;
      border-radius: 0.1rem;
      background: -webkit-linear-gradient(to top ,#0669be, #4cacff); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to top,#0669be, #4cacff); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to top,#0669be, #4cacff); /* Firefox 3.6 - 15 */
      background: linear-gradient(to top,#0669be, #4cacff);
      box-shadow: #2c4b64 0px 0px 0.2rem;
    }
    .way:nth-child(2) {
      margin: 0 2rem;
    }
  }
  .question {
    font-size: 0.5rem;
    a {
      color: #0066cc;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/selectCheck.vue